import React, { Component, useState, useEffect } from "react";
import { hot } from "react-hot-loader";
//import { ImportSteps } from "./ImportSteps";
import { Alert, Progress, Spin, Collapse, message, notification } from "antd";
import { QueuesApi, Queue } from "../../services/generated-sdk";

function ShowQueueStatus(props) {
  const [inProgress, setinProgress] = useState(false);
  //const [importProgress, setimportProgress] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const [intervalRef, setIntervalRef] = useState<any>(null);
  const [queueData, setQueueData] = useState<Queue>(null);
  //const [importSummary, setImportSummary] = useState<ImportSummary>();

  //const intervalRef = React.useRef<any>();
  const MESSEAGE_SHOW_DURATION = 3;

  //const tcAPI = new TestCasesApi();
  //const importID = sessionStorage.getItem("tc_import_queue");

  //   useInterval(() => {
  //     fetchQueueStatus();
  //   }, 1000);

  /*
  const interval = useInterval(
    () => {
      return fetchQueueStatus();
    },
    1000,
    true
  );
  */

  /*
  useEffect(
    () => {
      if (isCompleted) clearInterval(intervalRef.current);
    },
    [isCompleted]
  );
  */

  useEffect(
    () => {
      if (props.queueId && !inProgress) {
        setinProgress(true);
        if (props.noUI == undefined || props.noUI !== true) {
          // message.loading("Action in progress..", MESSEAGE_SHOW_DURATION);
        }
        fetchQueueStatus();
        //objectListToAddOnQueue.map(refObject => addToQueue(refObject));
        /*
        setIntervalRef(setInterval(
          () => fetchQueueStatus(),
          QUEUE_CHECK_INTERVAL
        ));
        //setIsStarted(true);
        */
      }
    },
    [props] //objectListToAddOnQueue
  );

  const clearTimer = () => {
    console.log("Clearing time.....");
    // if (intervalRef) clearInterval(intervalRef);
    // setIntervalRef(undefined);
  };

  const fetchQueueStatus = async () => {
    if (!props.queueId || isCompleted) {
      //if (interval["stop"]) interval["stop"]();
      //clearTimer();
      return;
    }
    const API = new QueuesApi();
    try {
      const response = await API.getQueue({
        id: props.queueId
      });

      setQueueData(response);
      if (parseInt(response.status.toString()) > 1) {
        //clearTimer();
        console.log("task completed..........");
        setIsCompleted(true);
        //stop();
        //fetchImportSummary(importID);
        if (props.noUI == undefined || props.noUI !== true) {
          if (!props.hideNotifications) {
            notification.success({
              message: "Action completed"
            });
          }
        }
        props.onComplete(
          parseInt(response.status.toString()) == 2 ? true : false,
          response.results
        );
      } else {
        if (!props.endQueueCheck) {
          setTimeout(fetchQueueStatus, 5000);
        }
      }
      //setimportProgress(status.percent);
      //setqueueStatus(status.status);
    } catch (e) {
      console.log({ "FETCH QUQUE ERROR": e });
      //handleError(e.status);
    }
  };

  /*
  const fetchImportSummary = async importID => {
    const API = new TestCaseImportApi();
    try {
      const summary = await API.getImportSummary({ importTaskID: importID });
      setImportSummary(summary);
    } catch (e) {
      handleError(e.status);
    }
  };
  */

  if (!props.queueId) {
    return (
      <div>
        <Alert type="warning" message="No queue information found." />
      </div>
    );
  }

  return (
    <div>
      {isCompleted === false ? (
        <div>
          {props.noUI != undefined && props.noUI === true ? (
            <div />
          ) : (
            <div
              style={
                props.progressType !== undefined && props.progressType
                  ? { width: props.width ? props.width : "200px" }
                  : {}
              }
            >
              {props.showProgressOnly != undefined &&
              props.showProgressOnly === true ? null : (
                <div>
                  {" "}
                  {queueData &&
                  queueData.status &&
                  parseInt(queueData.status.toString()) == 1
                    ? "In Progress"
                    : "Pending"}
                </div>
              )}
              <Progress
                percent={
                  queueData && queueData.percentDone ? queueData.percentDone : 0
                }
                type={
                  props.progressType !== undefined && props.progressType
                    ? props.progressType
                    : "circle"
                }
                // type="circle"
                // width={60}
                // size="small"
                //status={queueData && queueData.percentDone ?  queueData.percentDone > 75 ? "success" : queueData.percentDone > 25 ? "normal" : "exception" : "exception"}
                showInfo={true}
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068"
                }}
              />
            </div>
          )}
        </div>
      ) : null}

      {/*
      ) : queueData && queueData.status && parseInt(queueData.status.toString()) == 2 ? (
        <div>
          <Progress 
            percent={queueData && queueData.percentDone ? queueData.percentDone : 0} 
            type="circle" width={80}
          />
        </div>
      ) : queueData && queueData.status && parseInt(queueData.status.toString()) == 3 ? (
        <div>
          <Progress 
            percent={queueData && queueData.percentDone ? queueData.percentDone : 0} 
            type="circle" width={80}
            status="exception"
          />
        </div>
      ) : (
        <Spin />
      )
      */}
    </div>
  );
}
export default hot(module)(ShowQueueStatus);
